import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "text-right" };
const _hoisted_2 = { class: "js-number-unfulfilled js-notification-ellipsis" };
const _hoisted_3 = { class: "text-right" };
const _hoisted_4 = { class: "js-number-fulfilled js-notification-ellipsis" };
const _hoisted_5 = { class: "date-time" };
const _hoisted_6 = { class: "icon" };
const _hoisted_7 = ["onClick"];
import EditComponentDrawer from "src/shared/v-components/component/edit-component-drawer/EditComponentDrawer.vue";
import TableRow from "src/shared/v-components/ui/table/TableRow.vue";
import { onMounted, ref, computed } from "vue";
import { RouterLink } from "vue-router";
import rewardStateSummaryService from "src/account-rewards/reward-state-summary-service";
import Numbers from "src/shared/Numbers";
import dateTimeService from "src/shared/date-time-service";
import DrawerTrigger from "src/shared/v-components/ui/drawer/DrawerTrigger.vue";
import RewardSupplierWorkflow from "../workflow/RewardSupplierWorkflow";
import Strings from "src/shared/Strings";
const NO_VALUE = "--";
export default /*#__PURE__*/ _defineComponent({
    __name: 'IntegrationRewardSupplierListItem',
    props: {
        rewardSupplier: {},
        eventBus: {}
    },
    setup(__props) {
        const props = __props;
        const unfulfilledValue = ref(NO_VALUE);
        const fulfilledValue = ref(NO_VALUE);
        const selectedComponentId = computed(() => props.rewardSupplier.getComponentId());
        const onSave = () => {
            props.eventBus.trigger(RewardSupplierWorkflow.EVENTS.COMPLETE);
        };
        const onDelete = () => {
            props.eventBus.trigger(RewardSupplierWorkflow.EVENTS.REMOVED);
        };
        onMounted(() => {
            rewardStateSummaryService
                .getNumberFulfilled(props.rewardSupplier.id)
                .done((value) => {
                if (isNaN(value)) {
                    fulfilledValue.value = NO_VALUE;
                }
                else {
                    fulfilledValue.value = Numbers.humanize(value);
                }
            })
                .fail(() => {
                fulfilledValue.value = NO_VALUE;
            });
            rewardStateSummaryService
                .getNumberUnfulfilled(props.rewardSupplier.id)
                .done((value) => {
                if (isNaN(value)) {
                    unfulfilledValue.value = NO_VALUE;
                }
                else {
                    unfulfilledValue.value = Numbers.humanize(value);
                }
            })
                .fail(() => {
                unfulfilledValue.value = NO_VALUE;
            });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(TableRow, null, {
                default: _withCtx(() => [
                    _createElementVNode("td", null, [
                        _createVNode(_unref(RouterLink), {
                            to: `/${_ctx.rewardSupplier.id}`
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(Strings).capitalize(_ctx.rewardSupplier.name)), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["to"])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(_ctx.rewardSupplier.getFormattedValue()), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_1, [
                        _createElementVNode("span", _hoisted_2, _toDisplayString(unfulfilledValue.value), 1 /* TEXT */)
                    ]),
                    _createElementVNode("td", _hoisted_3, [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(fulfilledValue.value), 1 /* TEXT */)
                    ]),
                    _createElementVNode("td", _hoisted_5, _toDisplayString(_unref(dateTimeService).formatToDateTime(_ctx.rewardSupplier.updated_date)), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_6, [
                        _createVNode(DrawerTrigger, null, {
                            trigger: _withCtx(({ openDrawer }) => [
                                _createElementVNode("i", {
                                    class: "fas fa-edit",
                                    onClick: openDrawer
                                }, null, 8 /* PROPS */, _hoisted_7)
                            ]),
                            drawer: _withCtx(({ drawerClosed }) => [
                                _createVNode(EditComponentDrawer, {
                                    "component-id": selectedComponentId.value,
                                    "should-publish": true,
                                    onSaved: _cache[0] || (_cache[0] = ($event) => (onSave())),
                                    onArchived: _cache[1] || (_cache[1] = ($event) => (onDelete())),
                                    onClosed: drawerClosed
                                }, null, 8 /* PROPS */, ["component-id", "onClosed"])
                            ]),
                            _: 1 /* STABLE */
                        })
                    ])
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
